export const WorkspaceConfigurationQueryKeys = {
  GetWorkspaceConfiguration: (workspaceId: string) => ['workspace-configuration', workspaceId]
}
